import { Skeleton } from '@/components/ui/skeleton';

export const MembersSkeleton = () => {
  return (
    <div className='p-4 w-full mx-auto'>
      <div className='animate-pulse space-y-6'>
        {/* Header with title and add member button */}
        <div className='flex justify-between items-center'>
          <Skeleton className='h-8 w-32' />
          <Skeleton className='h-10 w-32' />
        </div>

        {/* Table */}
        <div className='border rounded-lg overflow-hidden'>
          {/* Table Header */}
          <div className='grid grid-cols-[80px_2fr_2fr_1fr_120px] gap-4 p-4 bg-muted/50 border-b'>
            <div className='w-10' /> {/* Avatar column */}
            <Skeleton className='h-4 w-24' /> {/* Name */}
            <Skeleton className='h-4 w-24' /> {/* Email */}
            <Skeleton className='h-4 w-16' /> {/* Role */}
            <div className='w-20' /> {/* Actions */}
          </div>

          {/* Table Body */}
          <div className='divide-y'>
            {[1, 2, 3, 4, 5].map((index) => (
              <div
                key={index}
                className='grid grid-cols-[80px_2fr_2fr_1fr_120px] gap-4 p-4 items-center'
              >
                {/* Avatar */}
                <Skeleton className='h-10 w-10 rounded-full' />

                {/* Name */}
                <div className='space-y-2'>
                  <Skeleton className='h-5 w-32' />
                  <Skeleton className='h-4 w-48' />
                </div>

                {/* Email */}
                <Skeleton className='h-4 w-48' />

                {/* Role */}
                <Skeleton className='h-4 w-24' />

                {/* Actions */}
                <div className='flex gap-2 justify-end'>
                  <Skeleton className='h-9 w-9 rounded-md' />
                  <Skeleton className='h-9 w-9 rounded-md' />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
